/** @type {string} */
export const DEFAULT_REGION_LABEL = "Your Local Area";

/**
 * @param {string | null | undefined} zipCode
 * @returns {string}
 */
export function getMarketRegionFromZip(zipCode) {
  if (zipCode == null || !String(zipCode).trim()) {
    return DEFAULT_REGION_LABEL;
  }
  const digits = String(zipCode).replace(/\D/g, "").slice(0, 5);
  if (digits.length < 5) {
    return DEFAULT_REGION_LABEL;
  }
  const zip = parseInt(digits, 10);

  if (zip >= 63000 && zip <= 63999) return "St. Louis";
  if ((zip >= 60000 && zip <= 60999) || (zip >= 60600 && zip <= 60699))
    return "Chicago";
  if (zip >= 10000 && zip <= 10499) return "New York";
  if (zip >= 90000 && zip <= 90999) return "Los Angeles";
  if (zip >= 75000 && zip <= 76999) return "Dallas";
  if (zip >= 77000 && zip <= 77999) return "Houston";
  if (zip >= 85000 && zip <= 85999) return "Phoenix";
  if (zip >= 19000 && zip <= 19999) return "Philadelphia";

  return DEFAULT_REGION_LABEL;
}

/**
 * @param {string | null | undefined} address
 * @returns {string | null}
 */
export function extractZipFromAddress(address) {
  if (!address || typeof address !== "string") return null;
  const m = address.match(/\b\d{5}(?:-\d{4})?\b/);
  return m ? m[0].replace(/\D/g, "").slice(0, 5) : null;
}
